<template>
  <div class="order">
    <div class="feature-container">
      <el-form :inline="true" :model="searchform" class="search-form" label-width="150px">
        <el-row>
          <el-col :span="2">
            <el-form-item>
              <el-button type="primary" @click="visible.createDialogVisible = true" size="medium">添加订单</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="支付订单号：">
              <el-input v-model="searchform.indentId" placeholder="支付订单号" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="购买手机号：">
              <el-input v-model="searchform.tel" placeholder="购买手机号" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单位/学校：">
              <el-input v-model="searchform.company" placeholder="单位或学校名称" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="padding-left:30px">
            <el-form-item>
              <el-button type="primary" @click="search" size="medium">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </div>
    <div class="list-container">
      <el-table :data="orderList" ref="multiple" border="" height="700">
        <el-table-column prop="indentId" label="订单号"></el-table-column>
        <el-table-column prop="contractNo" label="合同号"></el-table-column>
        <el-table-column prop="commodityName" label="购买内容"></el-table-column>
        <el-table-column prop="unitPrice" label="单价"></el-table-column>
        <el-table-column prop="payment" label="实付款"></el-table-column>
        <el-table-column prop="tel" label="购买手机号"></el-table-column>
        <el-table-column prop="client" label="客户名称"></el-table-column>
        <el-table-column prop="channel" label="销售渠道"></el-table-column>
        <el-table-column prop="occasions" label="购买时间">
          <template slot-scope="scope">
            {{scope.row.occasions?moment.utc(scope.row.occasions).local().format('YYYY-MM-DD HH:mm:ss'):scope.row.occasions}}
          </template>
        </el-table-column>
        <el-table-column prop="effectiveTime" label="生效时间">
          <template slot-scope="scope">
            {{scope.row.effectiveTime?moment.utc(scope.row.effectiveTime).local().format('YYYY-MM-DD HH:mm:ss'):scope.row.effectiveTime}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="expiresInDate" label="有效期"></el-table-column> -->
        <el-table-column prop="expiresTime" label="截止时间">
          <template slot-scope="scope">
            {{scope.row.expiresTime?moment.utc(scope.row.expiresTime).local().format('YYYY-MM-DD HH:mm:ss'):scope.row.expiresTime}}
          </template>
        </el-table-column>
        <el-table-column prop="indeneStatus" label="订单状态">
          <template slot-scope="scope">
            <el-tag  :type="getindenttype(scope.row.indeneStatus)" disable-transitions>{{getindentname(scope.row.indeneStatus)}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button @click.native.prevent="watch(scope.$index, scope.row)" type="text" size="small">查看支付宝订单</el-button>
            <el-button @click.native.prevent="refund(scope.$index, scope.row)" type="text" size="small" style="color:#f56c6c" v-if="scope.row.indeneStatus=='TRADE_SUCCESS'">退款</el-button>
            <el-button type="text" size="small" v-else disabled>退款</el-button>
            <el-button @click.native.prevent="edit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
            <!-- <el-button @click.native.prevent="deleteRow(scope.$index, scope.row)" type="text" size="small">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="orderTable.currentPage" :page-sizes="orderTable.pageSizes" :page-size="orderTable.pageSize" layout="total, prev, pager, next, sizes, jumper" :total="orderTable.total"></el-pagination>
    </div>

    <el-dialog title="支付宝账单详情" :visible.sync="visible.watchDialogVisible">

      <el-form label-position="left" :model="alipay" label-width="110px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付宝交易号">
              {{alipay.tradeNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商家订单号">
              {{alipay.outTradeNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="买家支付宝账号">
              {{alipay.buyerLogonId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易状态">
              {{getindentname(alipay.tradeStatus)}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额">
              {{alipay.totalAmount}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款时间">
              {{alipay.sendPayDate?new Date(alipay.sendPayDate).toLocaleString():''}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="买家支付宝的用户id">
              {{alipay.buyerUserId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="买家用户类型">
              {{alipay.buyerUserType=='PRIVATE'?'个人用户':'企业用户'}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商家优惠金额">
              {{alipay.mdiscountAmount}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-button @click="visible.watchDialogVisible = false" type="primary">确定</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </el-dialog>

    <el-dialog title="添加订单" :visible.sync="visible.createDialogVisible" width="26%">

      <el-form label-position="left" :model="createData" label-width="100px" :rules="validateOrder" ref="CreateForm">
        <el-form-item label="单位/学校：">
          <el-input v-model="theCompany" placeholder="单位或学校名称" size="medium" style="width:calc(100% - 65px);float:left"></el-input>
          <el-button @click="searchUser" type="primary" size="small" style="float:right;margin-top:4px">搜索</el-button>
        </el-form-item>
        <el-form-item label="手机号" prop="uid">
          <el-select v-model="createData.uid" placeholder="请选择" size="medium" filterable>
            <el-option v-for='(item,index) in userList' :key='index' :value="item.uid" :label="item.tel"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同号" prop="contractNo">
          <el-input v-model="createData.contractNo"></el-input>
        </el-form-item>
        <el-form-item label="购买内容" prop="commodityId">
          <el-select v-model="createData.commodityId" placeholder="请选择" size="medium">
            <el-option v-for='(item,index) in commodityList' :key='index' :value="item.commodityId" :label="item.commodityName"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="单价" prop="unitPrice">
          <el-input v-model="createData.unitPrice"></el-input>
        </el-form-item> -->
        <el-form-item label="实付款" prop="payment">
          <el-input v-model.number="createData.payment"></el-input>
        </el-form-item>
        <!-- <el-form-item label="有效期" prop="expiresInDate">
          <el-input type='number' v-model.number="createData.expiresInDate"><template slot="append">分钟</template></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="截止时间" prop="expiresTime">
          <el-date-picker v-model="createData.expiresTime" type="datetime" placeholder="选择截止时间" value-format='yyyy-MM-dd HH:mm:ss'></el-date-picker>
        </el-form-item> -->
        <!-- <el-form-item label="客户名称" prop="client">
          <el-input v-model="createData.client"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="销售渠道" prop="channel">
          <el-input v-model="createData.channel"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button @click="visible.createDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="createOrder">确定</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>

    <el-dialog title="编辑" :visible.sync="visible.updateDialogVisible" width="26%">

      <el-form label-position="left" :model="selectRow" label-width="100px" :rules="validateOrder" ref="UpdateForm">
        <el-form-item label="订单号" prop="indentId">
          <el-input v-model="selectRow.indentId" disabled></el-input>
        </el-form-item>
        <el-form-item label="合同号" prop="contractNo">
          <el-input v-model="selectRow.contractNo"></el-input>
        </el-form-item>
        <el-form-item label="购买内容" prop="commodityName">
          <el-input v-model="selectRow.commodityName" disabled></el-input>
        </el-form-item>
        <!-- <el-form-item label="单价" prop="unitPrice">
          <el-input v-model="selectRow.unitPrice"></el-input>
        </el-form-item> -->
        <el-form-item label="实付款" prop="payment">
          <el-input v-model.number="selectRow.payment"></el-input>
        </el-form-item>
        <!-- <el-form-item label="有效期" prop="expiresInDate">
          <el-input type='number' v-model.number="selectRow.expiresInDate"><template slot="append">分钟</template></el-input>
        </el-form-item> -->
        <el-form-item label="截止时间" prop="expiresTime">
          <el-date-picker v-model="selectRow.expiresTime" type="datetime" placeholder="选择截止时间" value-format='yyyy-MM-dd HH:mm:ss'></el-date-picker>
        </el-form-item>
        <el-form-item label="购买手机号" prop="tel">
          <el-input v-model="selectRow.tel" disabled></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="client">
          <el-input v-model="selectRow.client"></el-input>
        </el-form-item>
        <el-form-item label="销售渠道" prop="channel">
          <el-input v-model="selectRow.channel"></el-input>
        </el-form-item>
        <el-form-item label="订单状态" prop="indeneStatus">
          <el-select v-model="selectRow.indeneStatus" placeholder="请选择" size="medium">
            <el-option value="WAIT_BUYER_PAY" label="待支付"></el-option>
            <el-option value="TRADE_SUCCESS" label="支付成功"></el-option>
            <el-option value="TRADE_FINISHED" label="交易结束"></el-option>
            <el-option value="TRADE_CLOSED" label="交易关闭"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="visible.updateDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="updateOrder">确定</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>

</template>

<script>
var moment = require('moment')
export default {
  name: 'order',
  data () {
    return {
      moment: moment,
      uid: 0,
      searchform: {
      },
      orderList: [],
      commodityList: [],
      userList: [],

      orderTable: {
        total: 0,
        pageSizes: [10, 20, 50],
        pageSize: 20,
        currentPage: 1
      },
      visible: {
        createDialogVisible: false,
        watchDialogVisible: false,
        updateDialogVisible: false
      },
      validateOrder: {
        uid: [{
          required: true, message: '请选择手机号'
        }],
        payment: [{
          required: true, message: '请输入实付款金额'
        },
        {
          type: 'number', message: '请输入数字'
        }],
        commodityId: [{
          required: true, message: '请选择商品'
        }]
      },
      createData: {},
      selectRow: {
        expiresTime: ''
      },
      alipay: {},
      theCompany: ''
    }
  },
  created: async function () {
    var data = {}
    data.page = this.orderTable.currentPage
    data.size = this.orderTable.pageSize
    var res = await this.$$getOrderList(data)
    this.orderList = res.list
    this.orderTable.total = res.total

    this.commodityList = (await this.$$getCommodityList({ page: 1, size: 100 })).list

    this.userList = await this.$$searchUserList({ isPaged: false })
  },
  methods: {
    search () {
      if (Object.keys(this.searchform).length === 0) {
        this.$message.error('关键字不能为空')
        return
      }
      this.orderTable.currentPage = 1
      this.refreshList()
    },
    /**
                                * 获取角色颜色状态以及角色名称
                                */
    getindenttype (status) {
      switch (status) {
        case 'TRADE_SUCCESS':
          return 'success'

        case 'TRADE_FINISHED':
          return 'info'

        case 'WAIT_BUYER_PAY':
          return 'warning'

          // case 'wait_buyer_pay':
          //   return 'warning'

        case 'TRADE_CLOSED':
          return 'danger'

        default:
          return 'primary'
      }
    },
    getindentname (status) {
      switch (status) {
        case 'TRADE_SUCCESS':
          return '支付成功'

        case 'TRADE_FINISHED':
          return '交易结束'

        case 'WAIT_BUYER_PAY':
          return '待支付'

          // case 'wait_buyer_pay':
          //   return '待支付'

        case 'TRADE_CLOSED':
          return '交易关闭'

        default:
          return status
      }
    },
    refreshList: async function () {
      this.searchform.page = this.orderTable.currentPage
      this.searchform.size = this.orderTable.pageSize
      var res = await this.$$getOrderList(this.searchform)
      this.orderTable.total = res.total
      this.orderList = res.list
      // this.orderList.forEach((val) => {
      //   if (val.commodityId) {
      //     var commodity = await this.$$getDeviceinfo(val.commodityId);
      //     val.commodityName = commodity.commodityName;
      //   }
      // })
    },
    /**
                                       * 分页操作
                                       */
    handleSizeChange (val) {
      this.orderTable.pageSize = val
      this.refreshList()
    },
    handlePageChange (val) {
      this.orderTable.currentPage = val
      this.refreshList()
    },
    indexMethod (index) {
      return index + 1 + this.orderTable.pageSize * (this.orderTable.currentPage - 1)
    },
    watch: async function (index, row) {
      this.alipay = await this.$$getAlipayInfo(row.indentId)
      this.visible.watchDialogVisible = true
    },
    refund: async function (index, row) {
      await this.$$AlipayRefund(row.indentId).then(() => {
        this.$message.success('退款成功！')
        this.refreshList()
      })
    },
    edit (index, row) {
      this.selectRow = JSON.parse(JSON.stringify(row))
      if (this.selectRow.expiresTime) {
        this.selectRow.expiresTime = moment.utc(this.selectRow.expiresTime).local().format('YYYY-MM-DD HH:mm:ss')
      }
      this.visible.updateDialogVisible = true
    },
    createOrder () {
      this.$refs.CreateForm.validate(async valid => {
        if (valid) {
          this.createData.count = 1
          this.createData.client = 'msmt'
          var res = await this.$$postOrder(this.createData)
          if (res) {
            this.refreshList()
            this.visible.createDialogVisible = false
          }
        }
      })
    },
    updateOrder () {
      this.$refs.UpdateForm.validate(async valid => {
        if (valid) {
          var param = JSON.parse(JSON.stringify(this.selectRow))
          if (this.selectRow.expiresTime) {
            param.expiresTime = moment(this.selectRow.expiresTime).utc().format('YYYY-MM-DD HH:mm:ss')
          }
          var res = await this.$$updateOrder(param)
          if (res) {
            this.refreshList()
            this.visible.updateDialogVisible = false
          }
        }
      })
    },
    deleteRow (index, row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$$deleteOrder(row.uid).then(() => {
          this.$message.success('删除成功！')
          this.refreshList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async searchUser () {
      this.userList = await this.$$searchUserList({ isPaged: false, company: this.theCompany })
    }

  }
}
</script>

<style lang="scss" scoped>
.order {
    /* height: 100%;
    padding: 24px;
    box-sizing: border-box;
    background-color: rgb(240,242,245); */
}
.feature-container {
    margin: 20px;
    background-color: #ffffff;
}
.list-container {
    margin: 20px;
}

.el-select {
    width: 100%;
}
/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}
</style>
